import Reveal from "@/components/base/Reveal";
import { timeline } from "@/mocks/timeline";

export default function TimelineSection() {
  return (
    <section id="timeline" className="py-16 md:py-24 bg-foreground-950">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-label tracking-widest text-accent-400 uppercase">Classics Timeline</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50">经典年表：这类电影怎么一路走来</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200">
              从家庭内部的小事，到群像式的社会观察，创作重心在几十年里不断移动。按时间读一遍，
              你会更容易理解为什么某些作品会被反复提起。
            </p>
          </div>
        </Reveal>

        <ol className="mt-12 relative">
          <span className="hidden md:block absolute left-[130px] top-2 bottom-2 w-px bg-background-50/15"></span>
          {timeline.map((item, i) => (
            <Reveal key={item.period} delay={i * 60}>
              <li className="relative flex flex-col md:flex-row gap-3 md:gap-8 py-5 md:py-6 md:pl-0">
                <div className="md:w-[110px] shrink-0 md:text-right">
                  <span className="font-heading text-lg md:text-xl font-semibold text-accent-400 whitespace-nowrap">
                    {item.period}
                  </span>
                </div>
                <span className="hidden md:flex absolute left-[124px] top-[34px] w-3 h-3 rounded-full bg-accent-400 ring-4 ring-foreground-950"></span>
                <div className="md:pl-8 flex-1">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-background-50">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-background-300 max-w-3xl">{item.text}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}